module.exports = __webpack_public_path__ + "img/trip_22.f35821c4.jpg";